import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { FiMapPin, FiPhone, FiRefreshCw, FiSearch, FiX } from "react-icons/fi";
import { getPickupPoints, getPickupPointsByPage } from "../../actions";
import Pagination from "../common/Pagination";

const PickupPointListModal = ({
  pickupPoints,
  loading,
  errors,
  current,
  count,
  pageSize,
  selectedId,
  onSelect,
  onClose,
  getPickupPoints,
  getPickupPointsByPage,
}) => {
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    getPickupPoints(pageSize);
  }, [getPickupPoints, pageSize]);

  const handleSearch = useCallback(
    (value) => {
      setSearchText(value);
      getPickupPoints(pageSize, value);
    },
    [getPickupPoints, pageSize],
  );

  let list;
  if (loading) {
    list = <div className="spinner-border text-dark m-auto"></div>;
  } else if (errors) {
    list = <p className="mb-0 text-danger">{errors}</p>;
  } else if (pickupPoints.length === 0) {
    list = (
      <p className="mb-0 text-muted">
        {searchText ? "No results found." : "No pickup points available."}
      </p>
    );
  } else {
    list = pickupPoints.map((item) => {
      const { id, name, address = {} } = item;
      const { street1, street2, city, zip_code, country, phone } = address;
      return (
        <div
          key={id}
          className={`address-list-item-container d-flex flex-row justify-content-between align-items-center${selectedId === id ? " active" : ""}`}
          onClick={() => onSelect(item)}
        >
          <div className="address-list-item d-flex flex-column">
            <h3>{name}</h3>
            <div className="address-line">
              <FiMapPin size={13} className="line-icon" />
              <span>{`${street1}${street2 ? `, ${street2}` : ""}${city ? `, ${city}` : ""}${zip_code ? `, ${zip_code}` : ""}${country ? `, ${country}` : ""}`}</span>
            </div>
            {phone && (
              <div className="contact-line">
                <div className="contact-item">
                  <FiPhone size={13} className="line-icon" />
                  <span>{phone}</span>
                </div>
              </div>
            )}
          </div>
        </div>
      );
    });
  }

  return (
    <div className="modal col-12 p-0 d-flex justify-content-center justify-content-lg-start aligin-items-center">
      <div className="backdrop" onClick={onClose}></div>
      <div className="modal-content address-list settings-card d-flex col-11 col-lg-7 m-auto">
        <div className="list-head card-section head d-flex flex-row justify-content-between align-items-center">
          <div className="d-flex flex-row align-items-center">
            <h3 className="mb-0">Pickup Points</h3>
            <FiRefreshCw
              size={16}
              className="refresh-icon mx-3"
              onClick={() => getPickupPoints(pageSize, searchText)}
            />
          </div>
          <a onClick={onClose}>
            <FiX size={25} />
          </a>
        </div>
        <div className="list-content card-section last">
          <div className="search-action">
            <input
              type="text"
              placeholder="Search..."
              onChange={(e) => handleSearch(e.target.value)}
              value={searchText}
            />
            <FiSearch size={25} className="search-icon" />
            <FiX
              size={25}
              className={`clear-icon ${searchText ? "active" : ""}`}
              onClick={() => handleSearch("")}
            />
          </div>
          {list}
        </div>
        <div className="list-content card-section last">
          <Pagination
            current={current}
            count={count}
            pageSize={pageSize}
            getListByPage={(pageNo) =>
              getPickupPointsByPage(pageNo, pageSize, searchText)
            }
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ addressList }) => ({
  pickupPoints: addressList.pickupPoints,
  loading: addressList.loading,
  errors: addressList.errors,
  current: addressList.pickupCurrentPage,
  count: addressList.pickupPointsResponse?.count,
  pageSize: addressList.pageSize,
});

export default connect(mapStateToProps, {
  getPickupPoints,
  getPickupPointsByPage,
})(PickupPointListModal);
